import { isNull, isUndefined } from '@/utils/comparators'
import {
  GLOBAL_UNLIMITED_PRODUCT_CATEGORY_TYPE,
  GLOBAL_LIMITED_PRODUCT_CATEGORY_TYPE,
  UNLIMITED_PRODUCT_CATEGORY_TYPE,
  LIMITED_PRODUCT_CATEGORY_TYPE,
  SIM_PRODUCT_TYPE,
  MEMBERSHIP_PRODUCT_TYPE,
  REBIN_PRODUCT_TYPE
} from '@/utils/constants'

const isGlobalUnlimited = (product) => {
  if (isNull(product) || isUndefined(product.categories)) {
    return false
  }
  let is = false
  product.categories.forEach(function (c) {
    if (c.indexOf(GLOBAL_UNLIMITED_PRODUCT_CATEGORY_TYPE) !== -1) {
      is = true
    }
  })
  return is
}

const isGlobalLimited = (product) => {
  if (isNull(product)) {
    return false
  }
  let is = false
  product.categories.forEach(function (c) {
    if (c.indexOf(GLOBAL_LIMITED_PRODUCT_CATEGORY_TYPE) !== -1) {
      is = true
    }
  })
  return is
}

const isUnlimited = (product) => {
  if (isNull(product)) {
    return false
  }
  let is = false
  product.categories.forEach(function (c) {
    if (c.indexOf(UNLIMITED_PRODUCT_CATEGORY_TYPE) !== -1) {
      is = true
    }
  })
  return is
}

const isLimited = (product) => {
  if (isNull(product)) {
    return false
  }
  let is = false
  product.categories.forEach(function (c) {
    if (c.indexOf(LIMITED_PRODUCT_CATEGORY_TYPE) !== -1) {
      is = true
    }
  })
  return is
}

const isSimPlan = (product) => {
  return isNull(product) ? false : product.productType === SIM_PRODUCT_TYPE
}

const isWelcomeOffer = (product) => {
  if (isNull(product)) {
    return false
  }
  // backend apis are inconsistent returning id or productId depending on endpoint
  let id = !isUndefined(product.id) ? product.id : product.productId
  return (id >= 3700 && id <= 3799) || (id === 3358)
}

const isWorldCredits = (product) => {
  if (isNull(product)) {
    return false
  }
  // backend apis are inconsistent returning id or productId depending on endpoint
  let id = !isUndefined(product.id) ? product.id : product.productId
  return (id >= 1000 && id <= 1010)
}

const isTrial = (product) => {
  if (isNull(product)) {
    return false
  }
  return product.discountDays > 0
}

const isFreeUnlimited = (product) => {
  if (isNull(product)) {
    return false
  }
  return isUnlimited(product) && product.productPrice.amount === 0
}

const isUsUnlimited = (product) => {
  if (isNull(product)) {
    return false
  }
  let id = !isUndefined(product.id) ? product.id : product.productId
  return id === 8151 || id === 8652
}

const isMxUnlimited = (product) => {
  if (isNull(product)) {
    return false
  }
  let id = !isUndefined(product.id) ? product.id : product.productId
  return id === 8672
}

const isMembership = (product) => {
  if (isNull(product) || isUndefined(product) || !product.productType) {
    return false
  }
  return product.productType.toLowerCase() === MEMBERSHIP_PRODUCT_TYPE.toLowerCase()
}

const isRebin = (product) => {
  if (isNull(product)) {
    return false
  }
  return product.productType === REBIN_PRODUCT_TYPE
}

const isTrail = (product) => {
  if (isNull(product)) {
    return false
  }

  return product.discountDays !== 0
}

export {
  isGlobalUnlimited,
  isGlobalLimited,
  isUnlimited,
  isLimited,
  isSimPlan,
  isWelcomeOffer,
  isWorldCredits,
  isTrial,
  isFreeUnlimited,
  isUsUnlimited,
  isMxUnlimited,
  isMembership,
  isRebin,
  isTrail
}



// WEBPACK FOOTER //
// ./src/utils/productTypes.js